import React, { Component } from 'react'
import '../PageNotFound/PageNotFound.scss'
export default class PageNotFound extends Component {
    render() {
        return (
            <div class="user-log-in-side-image"><h2 class="user-log-in-side-image__title1">OOPS :( PAGE NOT FOUND TRY ANOTHER LINK</h2></div>
        )
    }
}
